module.exports = __webpack_public_path__ + "img/right-left.c412a5fc.gif";